'use strict';

var Varint = require('varint');

var _require = require('buffer'),
    Buffer = _require.Buffer; // Encode the passed length `value` to the `target` buffer at the given `offset`


var varintEncode = function varintEncode(value, target, offset) {
  var ret = Varint.encode(value, target, offset);
  varintEncode.bytes = Varint.encode.bytes; // If no target, create Buffer from returned array

  return target || Buffer.from(ret);
};

module.exports = varintEncode;